import styled from "@emotion/styled";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import theme from "../../theme";

export const FormWrapper = styled(Box)`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  padding: 8px;
`;

export const UserProfileWrapper = styled(Box)`
  display: flex;
  gap: 10px;
  flex-direction: column;
`;

export const KnowMeMoreButton = styled(Button)`
  text-transform: none;
  width: fit-content;
  margin-bottom: 16px;
`;

export const FormControlLayout = styled(FormControl)`
  display: flex;
`;

export const PhoneNumberLayout = styled(Box)`
  display: flex;
  align-items: flex-end;
  width: 100%;
  margin: 12px 0 16px 0;
`;

export const PhoneNumberInput = styled(TextField)`
  width: 80%;
`;

export const CountryCodeSelect = styled("select")`
  width: 40%;
  border: none;
  height: 37px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  margin-right: 13px;
  font-size: 1rem;
  color: rgb(0, 0, 0, 0.87);
  outline: none;
`;

export const InputPhotoWrapper = styled(Box)`
  width: 150px;
  height: 150px;
  background: ${theme.palette.primary.main};
  align-self: center;
  border-radius: 50%;
  position: relative;
`;

export const CameraIconButton = styled(IconButton)`
  position: absolute;
  z-index: 1;
  background-color: ${theme.palette.primary.main};
  bottom: 4px;
  right: 4px;
  height: 40px;
  width: 40px;
  border: 2px solid ${theme.palette.common.white};

  &:hover {
    background-color: ${theme.palette.primary.main};
  }

  & > svg {
    color: ${theme.palette.common.white};
  }
`;

export const CapturePhotoButton = styled(IconButton)`
  position: absolute;
  z-index: 1;
  background-color: ${theme.palette.primary.main};
  bottom: -28px;
  right: 0;
  left: 0;
  margin: auto;
  height: 56px;
  width: 56px;

  &:hover {
    background-color: ${theme.palette.primary.main};
  }

  & > svg {
    color: ${theme.palette.common.white};
  }
`;

export const PaperProp = {
  overflow: "visible",
  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
  mt: 1.5,
  "&:before": {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    left: 14,
    width: 10,
    height: 10,
    bgcolor: "background.paper",
    transform: "translateY(-50%) rotate(45deg)",
    zIndex: 0,
  },
};

export const SaveButton = styled(Button)`
  text-transform: none;
`;

export const QuestionText = styled(Typography)`
  font-size: 14px;
  margin-bottom: 4px;
`;

export const QuestionWrapper = styled(Box)``;

export const QuestionAnswersContainer = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
  margin-top: 8px;
  padding: 8px;
`;

export const PhotoCaptureWindow = styled(Box)`
  height: 480px;
  margin: 8px 8px 36px 8px;
  background: ${theme.palette
    .grey[400]}; //TODO: Added temporary background color
  border-radius: 8px;
  position: relative;
`;

export const TakePhotoWrapper = styled(Box)`
  margin: 8px;
`;
